import posthog from 'posthog-js';

export const initPostHog = () => {
  const key = import.meta.env.VITE_POSTHOG_KEY;
  const host = import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com';

  if (!key) {
    console.warn('PostHog key not found, analytics disabled');
    return;
  }

  posthog.init(key, {
    api_host: host,
    autocapture: true,
    capture_pageview: true,
    capture_pageleave: true,
    persistence: 'localStorage+cookie',
    loaded: (instance) => {
      if (import.meta.env.DEV) {
        instance.debug();
      }
    },
  });

  console.log('✅ PostHog initialized');
};

export { posthog };
